import { createTheme } from "@mui/material/styles";
import { meadowgreen } from "./colors";

declare module "@mui/material/styles" {
  interface Palette {
    standout: string;
  }
  interface PaletteOptions {
    standout?: string;
  }
  interface Theme {
    customShadows: {
      subtle: string;
    };
  }
  interface ThemeOptions {
    customShadows?: {
      subtle?: string;
    };
  }
}

const theme = createTheme({
  customShadows: {
    subtle: '0px 4px 12px rgba(0, 0, 0, 0.05)',
  },
  palette: {
    mode: "light",
    primary: {
      main: "#003322",
      contrastText: meadowgreen,
    },
    secondary: {
      main: "#FFD646",
    },
    background: {
      default: "#FCF7EE",
      paper: "#FFFFFF",
    },
    error: {
      main: "#c62828",
    },
    text: {
      primary: "#262626",
      secondary: "#2626268F",
    },
    standout: meadowgreen,
  },
  typography: (palette) => ({
    fontFamily: '"Karla", "Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontFamily: '"Bagoss", "Karla", "Roboto", "Helvetica", "Arial", sans-serif',
      fontWeight: 500,
      fontSize: "6rem",
    },
    h2: {
      fontFamily: '"Bagoss", "Karla", "Roboto", "Helvetica", "Arial", sans-serif',
      fontWeight: 300,
      fontSize: "3.75rem",
    },
    h3: {
      fontWeight: 400,
      fontSize: "3rem",
    },
    h4: {
      fontWeight: 400,
      fontSize: "2rem",
    },
    h5: {
      fontWeight: 400,
      fontSize: "1.5rem",
    },
    h6: {
      fontWeight: 700,
      fontSize: "1.25rem",
    },
    subtitle1: {
      fontWeight: 400,
      fontSize: "1rem",
    },
    subtitle2: {
      fontWeight: 500,
      fontSize: "0.875rem",
    },
    body1: {
      fontWeight: 400,
      fontSize: "1rem",
    },
    body2: {
      fontWeight: 400,
      fontSize: "0.875rem",
    },
    button: {
      fontWeight: 500,
      fontSize: "0.875rem",
      textTransform: "none",
    },
    caption: {
      fontWeight: 400,
      fontSize: "0.75rem",
      color: palette.text.secondary,
    },
  }),
  components: {
    MuiInputLabel: {
      styleOverrides: {
        shrink: {
          backgroundColor: "white",
          padding: "0 4px",
          textDecoration: "none",
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        notchedOutline: {
          "& legend": {
            width: "auto",
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '50px',
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: ({ theme }) => ({
          borderRadius: '10px',
          boxShadow: theme.customShadows.subtle,
        }),
      },
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          backgroundColor: '#f5f5f5',
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        head: {
          fontWeight: 700,
        },
      },
    },
  },
});

export default theme;
